import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import GridPhotos from 'components/common/GridPhotos';
import OrderWaiting from 'assets/images/order_waiting.png';
import { Typography } from 'antd';
import OrderStatusStyles from './styles';
import WaitingApproved from './WaitingApproved';
import DoneStatus from './DoneStatus';
import CancelStatus from './CancelStatus';

const ORDER_STATUS_HAS_ACCESS = [
  'waiting_approved',
  'pre_order',
  //  'delivery'
];

const OrderStatusContent = ({ orderStatus, onCancel, order }) => {
  if (ORDER_STATUS_HAS_ACCESS.indexOf(orderStatus?.status) > -1) {
    return (
      <OrderStatusStyles>
        <WaitingApproved onCancel={onCancel} item={orderStatus} order={order} />
      </OrderStatusStyles>
    );
  }

  if (orderStatus.status === 'done') {
    return (
      <OrderStatusStyles>
        <DoneStatus onCancel={onCancel} item={orderStatus} order={order} />
      </OrderStatusStyles>
    );
  }

  if (orderStatus.status === 'canceled') {
    return (
      <OrderStatusStyles>
        <CancelStatus onCancel={onCancel} item={orderStatus} order={order} />
      </OrderStatusStyles>
    );
  }

  return (
    <OrderStatusStyles>
      <Typography.Title level={3}>
        {i18next.t(`orders.orderStatus.default`)}
      </Typography.Title>
      <div className="html-content">
        <div
          dangerouslySetInnerHTML={{
            __html: orderStatus.note || i18next.t('orders.dontHaveInfo'),
          }}
        />
        {order?.products && (
          <GridPhotos images={order?.products?.[0]?.productImages || []} />
        )}
        {!order?.products && (
          <img className="orderStatusImage" src={OrderWaiting} alt="" />
        )}
      </div>
    </OrderStatusStyles>
  );
};

OrderStatusContent.propTypes = {
  order: PropTypes.object,
  orderStatus: PropTypes.object,
  onCancel: PropTypes.func,
};

export default OrderStatusContent;
